import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, ToastController, ActionSheetController, Events, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';
import { AppSettings } from '../services/app-settings';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';
// import { AppRate, AppRateCustomLocale, AppRatePreferences } from '@ionic-native/app-rate';
// import { a } from '@angular/core/src/render3';
// import { SocialSharing } from '@ionic-native/social-sharing';

import { LocalNotifications } from '@ionic-native/local-notifications';


@Component({
  templateUrl: 'app.html'
})



export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{ title: string, component: any, icon: string }>;
  previousConnectionStatus: any = 'ONLINE';
  firebasePlugin;
  userFullName: any = localStorage.getItem('userName');
  mercazName: any = localStorage.getItem('mercazName');
  personalImage: any = localStorage.getItem('personalImage');
  profilePhotoVisible: boolean = true;
  appCurrentVersion: any = '';
  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen,
    private appVersion: AppVersion,
    private alertCtrl: AlertController,
    private network: Network,
    private toastCtrl: ToastController,
    private iab: InAppBrowser,
    public actionSheetCtrl: ActionSheetController,
    public events: Events,
    private localNotifications: LocalNotifications,
    private modalCtrl: ModalController,
    // private appRate: AppRate,
    // private socialSharing: SocialSharing,
  ) {
    this.initializeApp();
    this.pages = [
      { title: 'ראשי', component: 'HomePage', icon: 'home-outline' },
      { title: 'הקבלות שלי', component: 'ReciptsPage', icon: 'copy-outline' },
      { title: 'ההזמנות שלי', component: 'MyordersmainPage', icon: 'document-outline' },
      { title: 'פעילויות לתשלום', component: 'FuturepayPage', icon: 'pricetag-outline' },
      { title: 'אירועים', component: 'EventsPage', icon: 'calendar-outline' },
      { title: 'חוגים', component: 'HugimlistPage', icon: 'people-outline' },
      { title: 'סיכום מפגש/שיעור', component: 'MeetingreviewmainPage', icon: 'school-outline' },
      { title: 'הביקורים שלי', component: 'ChipcheckerlogPage', icon: 'pin-outline' },
      // { title: 'צ׳אט', component: 'ChatPage', icon: 'chatboxes-outline' },
      { title: 'עדכון פרטים', component: 'UpdateinfoPage', icon: 'person-outline' },
      // { title: 'כתוב ביקורת', component: 'WriteReview', icon: 'star-outline' },
      { title: 'פנה אלינו', component: 'ContactusPage', icon: 'mail-outline' },
      { title: 'דרגו אותנו בחנות', component: 'RateStore', icon: 'star-outline' },
      { title: 'שיתוף', component: 'SharePage', icon: 'share-outline' },
      { title: 'התנתקות', component: 'LogOut', icon: 'exit-outline' },
    ];

    events.subscribe('userDataEvent', (data) => {
      if (data['personalImage']) {
        this.personalImage = data['personalImage'];
        this.profilePhotoVisible = true;
      }
      if (data['personalFullName']) {
        this.userFullName = data['personalFullName'];
      }
    });
  }

  private applySafeAreaInsets() {
    if (!this.platform.is('android')) {
      return;
    }
    try {
      const root = document.documentElement;
      const prevTop = parseFloat(root.style.getPropertyValue('--sat')) || 0;
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;padding-top:env(safe-area-inset-top);padding-bottom:env(safe-area-inset-bottom);';
      document.body.appendChild(probe);
      const computed = window.getComputedStyle(probe);
      let top = parseFloat(computed.paddingTop) || 0;
      let bottom = parseFloat(computed.paddingBottom) || 0;
      document.body.removeChild(probe);

      // Android 15+ edge-to-edge: the WebView fills the screen, but env() is
      // sometimes 0. Detect a full-screen viewport and fall back to 40px.
      const coversScreen = window.innerHeight >= (window.screen.height * 0.97);
      if (coversScreen && top < 1) {
        top = 40;
      }

      root.style.setProperty('--sat', top + 'px');
      root.style.setProperty('--sab', bottom + 'px');
      if (document.body) {
        document.body.style.setProperty('--sat', top + 'px');
        document.body.style.setProperty('--sab', bottom + 'px');
      }

      if (prevTop !== top) {
        try {
          this.statusBar.backgroundColorByHexString('#3f51b5');
          this.statusBar.styleLightContent();
          // Edge-to-edge: keep the system bar transparent so the app-blue
          // strip shows through. Older Android still uses a native bar color.
          this.statusBar.overlaysWebView(top > 0);
        } catch (e) { /* noop */ }
        setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
      }
    } catch (e) { /* noop */ }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleLightContent();
      this.statusBar.backgroundColorByHexString('#3f51b5');
      this.applySafeAreaInsets();
      setTimeout(() => this.applySafeAreaInsets(), 300);
      this.platform.resize.subscribe(() => this.applySafeAreaInsets());
      this.splashScreen.hide();
      this.checkVersion();
      this.initializeNetworkEvents();

      // Track cold-start app launches so the rate-app modal can appear from the 2nd run on.
      try {
        const raw = localStorage.getItem('rateModalAppLaunches');
        const current = raw ? parseInt(raw, 10) : 0;
        const next = isNaN(current) ? 1 : current + 1;
        localStorage.setItem('rateModalAppLaunches', String(next));
      } catch (e) { /* noop */ }


      let userid: number = Number(localStorage.getItem('user_id'));
      // if (userid && userid != "undefined") {
      if (userid && userid > 0) {
        this.nav.setRoot(HomePage);
      } else {
        this.nav.setRoot('LoginPage');
      }

      this.firebasePlugin = (<any>window).FirebasePlugin;

      if (this.platform.is('cordova')) {

        if (this.platform.is('android')) {
          this.initializeFireBaseAndroid();

          this.localNotifications.requestPermission().then((pushRequestData) => {
            console.log("requestPermission", pushRequestData)
          }, (pushRequestDataError => {
            console.log("requestPermission", pushRequestDataError)
          }));




          try {
            this.localNotifications.cancel(1);
          } catch {

          }


          this.localNotifications.on('click').subscribe((notification: any) => {
            if (notification.id === 2) {
              this.openRateAppModal();
            }
          });


        }
        if (this.platform.is('ios')) {
          this.initializeFireBaseIos();
        }
      }

      this.platform.registerBackButtonAction(() => {
        if (this.nav.length() == 1) {
          let alert = this.alertCtrl.create({
            title: 'אישור יציאה מהאפליקציה',
            //message: 'Do you want to exit?',
            buttons: [
              {
                text: "יציאה", handler: () => {
                  this.platform.exitApp();
                }
              },
              { text: "ביטול", role: 'cancel' }
            ]
          });
          alert.present();
        } else
          this.nav.pop();
      });

      // this.appRate.preferences = {
      //   storeAppURL: {
      //     ios: "1544346553",
      //     android: "market://details?id=com.atarix.activtec",
      //     //windows: 'ms-windows-store://review/?ProductId=<store_id>'
      //   },
      //   customLocale: {
      //     title: "אנא קחו רגע לדרג אותנו בחנות",
      //     message: "חוות דעתך חשובה לנו",
      //     cancelButtonLabel: "לא תודה",
      //     laterButtonLabel: "הזכר לי מאוחר יותר",
      //     rateButtonLabel: "דרג עכשיו",
      //     yesButtonLabel: "כן",
      //     noButtonLabel: "לא",
      //     appRatePromptTitle: "האם את/ה נהנה להשתמש באפליקציה?",
      //     feedbackPromptTitle: "מעוניין לתת חוות דעת?",
      //   },
      //   callbacks: {
      //     onRateDialogShow: function (callback) {
      //       console.log('dfcsd');
      //     },
      //     onButtonClicked: function (buttonIndex) {
      //       console.log('Selected Index is ' + buttonIndex);
      //     }
      //   },
      //   simpleMode: false,
      //   usesUntilPrompt: 3,
      //   // inAppReview: true,
      //   useLanguage: 'he',
      //   // useCustomRateDialog: false,
      // }

      // this.appRate.promptForRating(false);



    });
  }

  whatsNew(text) {
    if (typeof text == "object" && text.length > 0) {
      let textparse = '';
      text.forEach(element => {
        textparse += '<li>' + element + '</li>';
      });

      let alertBox = this.alertCtrl.create({
        title: 'מה חדש בגרסה זו',
        message: `<ul>` + textparse + ` </ul>`,
        buttons: ['אישור']
      });
      alertBox.present();
    }
    else {
      let alertBox = this.alertCtrl.create({
        title: 'לא הוגדרו עידכונים לגרסה זו',
        buttons: ['אישור']
      });
      alertBox.present();
    }
  }

  async checkVersion() {

    await this.appVersion.getVersionNumber().then((version) => {
      this.appCurrentVersion = version;
      let appPlatform = this.platform.is('android') ? 'android' : 'ios';
      fetch(AppSettings.APP_VERSION + '?platform=' + appPlatform)
        .then(response => response.json())
        .then(data => {
          let remote_version = data['app_version'];
          let whatsnew = data['whatsnew'];
          // let version: any = '2.2';
          if (remote_version > version) {
            let alertBox = this.alertCtrl.create({
              title: '<b>עידכון קיים</b>',
              subTitle: 'עידכון גרסה: ' + remote_version + ' זמין להורדה',
              buttons: [

                {
                  text: 'הורדה',
                  handler: () => {
                    let downloadlink = '';
                    if (this.platform.is('android')) {
                      downloadlink = 'https://play.google.com/store/apps/details?id=com.atarix.activtec';
                    } else {
                      downloadlink = 'https://apps.apple.com/us/app/%D7%90%D7%A7%D7%98%D7%99%D7%91%D7%98%D7%A7/id1544346553';
                    }
                    if (downloadlink) {
                      const browser = this.iab.create(downloadlink, '_system');
                      // window.open(downloadlink, '_blank', 'location=yes');
                    }
                  }
                },
                {
                  text: 'מה חדש בגרסה זו',
                  handler: () => {
                    this.whatsNew(whatsnew);
                  }
                },
                {
                  text: 'ביטול',
                  role: 'cancel',
                  handler: () => {
                    console.log('Cancel clicked');
                  }
                },
              ]
            });
            alertBox.present();
          }
        })
        .catch((apiError => {
        }));

    }, (versionError) => {
      console.log(versionError);
    });
  }



  private initializeFireBaseAndroid(): Promise<any> {

    return this.firebasePlugin.getToken(token => {
      // console.log("getToken",token);
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }

  private initializeFireBaseIos(): Promise<any> {

    return this.firebasePlugin.grantPermission(data => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }



  subscribeToPushNotificationEvents() {
    // Handle token refresh

    this.firebasePlugin.onTokenRefresh((token) => {
      this.sendPushtoserver(token);
    });


    this.firebasePlugin.onMessageReceived((notification) => {
      if (!notification.tap) {
        //alert(JSON.stringify(notification));
      }
      else {

      }
    })
  }


  async sendPushtoserver(token) {
    if (token) {
      // this.config.SetUserPush(token);
      localStorage.setItem("push", token);
      // await this.server.SavePush("save_push.php", token).then((data: any) => {
      // });
    }
  }



  public initializeNetworkEvents(): void {
    this.network.onDisconnect().subscribe(() => {
      if (this.previousConnectionStatus == "ONLINE") {
        this.presentToast("מנותק מהאינטרנט");
      }
      this.previousConnectionStatus = "OFFLINE";
    });
    this.network.onConnect().subscribe(() => {
      if (this.previousConnectionStatus == "OFFLINE") {
        this.presentToast("מחובר לאינטרנט");
      }
      this.previousConnectionStatus = "ONLINE";
    });

    this.network.onchange().subscribe(() => {

      setTimeout(() => {
        if (this.network.type === '2g' || this.network.type === '3g' || this.network.type === 'unknown') {
          this.presentToast("חיבור אינטרנט איטי מהרגיל");
        }
      }, 3000);

    });
  }

  openPage(page) {
    console.log("page", page);
    if (page.title == "התנתקות") {

      let alertBox = this.alertCtrl.create({
        title: '<b>האם לאשר התנתקות מהמערכת?</b>',
        subTitle: '',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'יציאה',
            handler: () => {
              localStorage.removeItem("mercazName");
              localStorage.removeItem("userName");
              localStorage.removeItem("user_id");
              localStorage.removeItem("mercazAllId");
              localStorage.removeItem("server");
              localStorage.removeItem("phone");
              localStorage.removeItem("mercazImage");
              localStorage.removeItem("personalImage");
              localStorage.removeItem("sendReciptEmail");
              this.personalImage = '';
              this.userFullName = '';
              this.mercazName = '';
              this.profilePhotoVisible = true;
              this.nav.setRoot('LoginPage');
            }
          }
        ]
      });
      alertBox.present();
    }
    else if (page.title == "ראשי") {
      this.nav.setRoot(HomePage);
    }
    else if (page.component === 'RateStore') {
      this.openRateAppModal();
    }
    else if (page.title == "שיתוף") {
      // this.socialSharing.share("אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru"
      //   , "אפליקציית אקטיבטק",
      //   "https://play-lh.googleusercontent.com/I2-crgd3Jm3r-wdKsUbgv_A90e5qiEChVTlYjKCdPPQ-5I6ZiJbiSMqbxRJsgF21Mi4N=s360-rw", "").then(() => {
      //   }).catch(() => {
      //     console.error("shareSheetShare: failed");
      //   });


      let actionSheet = this.actionSheetCtrl.create({
        title: 'שיתוף האפליקציה',
        cssClass: 'shareActionSheet',
        buttons: [

          {
            text: 'אימייל',
            icon: 'mail-outline',
            cssClass: 'shareActionSheet__btn-email',
            handler: () => {
              const browser = this.iab.create("mailto:?subject=אפליקציית אקטיבטק&body=אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru", '_system');
            }
          },
          {
            text: 'SMS',
            icon: 'text-outline',
            cssClass: 'shareActionSheet__btn-sms',
            handler: () => {
              console.log('Archive clicked');
              const browser = this.iab.create("sms:?&body=אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru", '_system');
            }
          },
          {
            text: 'WhatsApp',
            icon: 'logo-whatsapp',
            cssClass: 'shareActionSheet__btn-whatsapp',
            handler: () => {
              console.log('Archive clicked');
              const browser = this.iab.create("https://api.whatsapp.com/send?text=אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru", '_system');
            }
          },
          // {
          //   text: 'פייסבוק',
          //   icon: 'logo-facebook',
          //   handler: () => {
          //     const browser = this.iab.create("http://www.facebook.com/share.php?u=https://www.activtec.co.il/page.php?type=parent&id=2640&m=299", '_blank');
          //   }
          // },
          // {
          //   text: 'טוויטר',
          //   icon: 'logo-twitter',
          //   handler: () => {
          //     const browser = this.iab.create("http://twitter.com/share?text=אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru&url=https://www.activtec.co.il/page.php?type=parent&id=2640&m=299", '_blank');
          //   }
          // },
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });

      actionSheet.present();


    } else if (page.title == "כתוב ביקורת") {
      this.openRateAppModal();
    }
    else {
      this.nav.push(page.component);
    }
  }

  openRateAppModal() {
    const modal = this.modalCtrl.create('RateappmodalPage', {}, {
      cssClass: 'rate-app-modal',
      enableBackdropDismiss: true,
    });
    modal.onDidDismiss((data: any) => {
      if (data && (data.rated || data.later || data.closed)) {
        try { localStorage.setItem('rateModalShownV1', '1'); } catch (e) { /* noop */ }
      }
    });
    modal.present();
  }

  goProfile() {
    this.nav.push('UpdateprofilePage');
  }

  onMenuOpen() {
    this.syncProfileFromStorage();
  }

  syncProfileFromStorage() {
    this.personalImage = localStorage.getItem('personalImage');
    this.userFullName = localStorage.getItem('userName');
    this.mercazName = localStorage.getItem('mercazName');
    this.profilePhotoVisible = true;
  }

  public onImgError(ev: Event, kind: 'profile' | 'matnas' = 'profile'): void {
    const imgEl: any = ev && (ev.target as any);
    if (!imgEl) {
      return;
    }

    imgEl.onerror = null;

    if (kind === 'profile') {
      this.profilePhotoVisible = false;
    }
  }

  presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts